// extracted by mini-css-extract-plugin
export default {"notifications":"SideMenuNotifications_notifications__GaE3y","mark":"SideMenuNotifications_mark__SHS4i","shimmer":"SideMenuNotifications_shimmer__QDarG"};